var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7294 12.7753C14.8441 11.4244 15.5482 9.69163 15.5482 7.78267C15.5482 3.49486 12.0572 0 7.77411 0C3.49102 0 0 3.49486 0 7.78267C0 12.0705 3.49102 15.5653 7.77411 15.5653C9.65163 15.5653 11.4118 14.8899 12.7613 13.7445L18.8045 19.7944C18.9512 19.9413 19.1272 20 19.3033 20C19.4793 20 19.6553 19.9413 19.802 19.7944C20.066 19.5301 20.066 19.0602 19.802 18.7959L13.7294 12.7753ZM7.74477 14.1557C4.22442 14.1557 1.3788 11.3069 1.3788 7.78267C1.3788 4.25844 4.22442 1.40969 7.74477 1.40969C11.2651 1.40969 14.1107 4.25844 14.1107 7.78267C14.1107 11.3069 11.2651 14.1557 7.74477 14.1557Z",
    fill: "#152745",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.721992bf776251f91e29f2e48085ade7.svg";
export { ForwardRef as ReactComponent };